import { Component, Input, EventEmitter, Output, ViewChild, OnInit } from '@angular/core';
import { RpaConnectorDetail } from 'app/rpa-bots/core/rpa-details-details.types';
import { NgForm } from '@angular/forms';
import { AuthType, ConstAuthClientCredentials, UipathConnectionType } from '../common/models/enums';
import { BzgRadioChange } from 'bz-genome-angular/radio/radio-button/radio-button.component';
import { BzgModalService } from 'bz-genome-angular';
import { ConfirmModalComponent } from '../common-components/confirm-modal/confirm-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { IRpaConnectionUiPath } from 'app/rpa-bots/core/IRpaBots';

@Component({
  selector: 'uipath-configuration',
  templateUrl: 'uipath-configuration.component.html',
  styleUrls: ['uipath-configuration.component.scss']
})
export class UipathConfigurationComponent implements OnInit {
  private _botDetailData: RpaConnectorDetail;
  private _originalConnection: RpaConnectorDetail;
  public chartsVisible: boolean;
  public retriesVisible: boolean;
  public URL_REGEXP = /^((((https?|ftps?):\/\/))(%[0-9A-Fa-f]{2}|[-()_.!~*';\/?:@&=+$,A-Za-z0-9])+)([).!';\/?:,][[:blank:]])?$/;
  //public uipathConnectionType = UipathConnectionType;
  //public authType = AuthType;
  public constAuthClientCredentials = ConstAuthClientCredentials;
  public botDetailData: IRpaConnectionUiPath;
  change_onPremisoToCloudTitle: string;
  change_onPremisoToCloudMessage: string;

  @Output() save = new EventEmitter<any>();
  @Output() testConnection = new EventEmitter<any>();
  @Input() botDetail: RpaConnectorDetail;
  @Input() public uiPathOriginalConnection: IRpaConnectionUiPath;
  @ViewChild('botConfigForm', { static: false }) botConfigForm: NgForm;

  uipathConnectionType = {
    cloud: 'Cloud',
    onPremise: 'OnPremise'
  };

  authType = {
    apiAccess: 'ApiAccess',
    clientCredentials: 'ClientCredentials'
  };

  constructor(private _modalService: BzgModalService, private translate: TranslateService,) {
  }

  ngOnInit(): void {
    this.translate.get('RPA_BOTS.CONFIRMATION').subscribe(translation => {
      this.change_onPremisoToCloudTitle = translation;
    });
    this.translate.get('RPA_BOTS.CHANGE_DATA_CONFIGURACION').subscribe(translation => {
      this.change_onPremisoToCloudMessage = translation;
    });

    if (this.botDetail) {
      this._originalConnection = _.cloneDeep(this.botDetail);
    }
  }

  onClearAll() {
    this.botDetail = {
      ...this.botDetail,
      server: '',
      password: '',
      tenancyName: '',
      userNameOrEmailAddress: '',
      authType: AuthType.apiAccess,
      grantType: ConstAuthClientCredentials.grantType,
      authUrl: ConstAuthClientCredentials.authUrl
    } as IRpaConnectionUiPath;
    this.botConfigForm.reset();

  }

  updateBotDetailProperty(property: string, value: any) {
    this.botDetail = { ...this.botDetail, [property]: value };
  }

  isValid(): boolean {
    return !this.botConfigForm || this.botConfigForm.valid;
  }

  onTestConnection() {
    this.testConnection.emit(this.botDetail);
  }

  onSave() {
    this.showConfirmDialog(() => { this.save.emit(this.botDetail); })
  }

  get hasChanges(): boolean {
    return !_.isEqual(this._originalConnection, this._botDetailData);
  }

  showCharts() {
    this.chartsVisible = true;
    this.retriesVisible = false;
  }

  showRetries() {
    this.retriesVisible = true;
    this.chartsVisible = false;
  }

  closeCharts() {
    this.chartsVisible = false;
  }

  closeRetries() {
    this.retriesVisible = false;
  }

  selectConnectionType(connectionType: string) {
    (this.botDetail as IRpaConnectionUiPath).connectionType = connectionType;
  }

  public showConfirmDialog(callback) {
    const deleteModal = this._modalService.open(ConfirmModalComponent, {
      closeOnBackdropClick: false,
      closeOnRouterNavigation: true,
      data: {
        title: this.change_onPremisoToCloudTitle,
        message: this.change_onPremisoToCloudMessage,
        button: "OK"
      }
    });
    deleteModal.afterClosed().subscribe((result: string) => {
      if (result === 'ok') {
        callback();
      }
    })
  }
}
